/**
 * get total cost for cart items based on currency key
 * @param {Object} options
 * @param {Object[]} [options.addOns]
 * @param {string} options.currency
 * @param {Object[]} options.items
 * @return {string}
 */
export const getCartCost = ({ addOns, currency, items, promos }) => {
  return (
    items.reduce((acc, item) => {
      return acc + (item.prices[currency] ?? 0);
    }, 0) +
    (addOns
      ?.filter(({ selected }) => selected)
      .reduce((acc, addOn) => acc + (addOn[currency] ?? 0), 0) ?? 0) -
    (promos
      ?.filter(({ [currency]: value }) => value)
      .reduce((acc, promo) => acc + (promo[currency] ?? 0), 0) ?? 0)
  );
};

/**
 * get display currency for payment option based on value
 * @param  {Object} options
 * @param  {Object} options.paymentOption
 * @param  {number} options.value
 * @return {string}
 */
export const getDisplayCurrency = ({ paymentOption, value }) => {
  return value === 1 && paymentOption.currencySingular
    ? paymentOption.currencySingular
    : paymentOption.currency;
};
